import { useMutation, useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Types } from "Types";
import { Selectors as administrateurBienSelectors } from "../../redux/AdministrateurDeBien";
import { ActionCreators as BienActionCreator } from "../../redux/Bien";
import { Selectors as dossierLocationSelectors } from "../../redux/DossierLocation";
import Api, { IApi } from "../../services/Api";
import {
  Bien,
  BienDetail,
  NombrePieces,
  TypeBien,
} from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";

export const usePostBien = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dossierLocationRef = useSelector((state: Types.RootState) =>
    dossierLocationSelectors.getSelectedDossier(state)
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  return useMutation<BienDetail, any, { bien: Bien }>(
    // @ts-ignore
    (params: { bien: Bien }) =>
      (api &&
        dossierLocationRef &&
        api.addBien(params.bien, dossierLocationRef)) ||
      undefined,
    {
      onSuccess: (data: BienDetail) => {
        dispatch(BienActionCreator.addBienAsync.success(data));
        navigate("/dossier-location/situation-personnelle");
      },
      onError: (error, variables) => {
        // stopSubmit(variables.form, error.content);
      },
    }
  );
};

export const usePutBien = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const dossierLocationRef = useSelector((state: Types.RootState) =>
    dossierLocationSelectors.getSelectedDossier(state)
  );
  const statutDossier = useSelector((state: Types.RootState) =>
    dossierLocationSelectors.getStatutDossier(state)
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  return useMutation<BienDetail, any, { bien: Bien }>(
    // @ts-ignore
    (params: { bien: Bien }) =>
      api &&
      dossierLocationRef &&
      api.updateBien(params.bien, dossierLocationRef),
    {
      onSuccess: (data: BienDetail) => {
        dispatch(BienActionCreator.updateBienAsync.success(data));
        if (!statutDossier) {
          navigate("/dossier-location/situation-personnelle");
        } else {
          navigate("/dossier-location/synthese");
        }
      },
    }
  );
};

export const useGetBien = () => {
  const api: IApi = Api.create(getApiEndpoint());

  const adbId = useSelector((state: Types.RootState) =>
    administrateurBienSelectors.getAdbId(state)
  );
  const adbDetail = useSelector((state: Types.RootState) =>
    administrateurBienSelectors.getADBDetail(state)
  );

  const adbSelected = (adbId && adbId) || (adbDetail && adbDetail.identifiant);

  let site = useSelector((state: Types.RootState) =>
    administrateurBienSelectors.getSelectedSite(state)
  );

  // chargement du site de la duplication
  const refDossierDuplique = useSelector((state: Types.RootState) =>
    dossierLocationSelectors.getDossierDuplique(state)
  );

  const dossiersLocation = useSelector((state: Types.RootState) =>
    dossierLocationSelectors.getResultDossierLocation(state)
  );
  if (refDossierDuplique) {
    site =
      dossiersLocation &&
      dossiersLocation.elements?.find(
        (dos) => dos.reference === refDossierDuplique
      )?.site;
    // site = dossierDuplique && dossierDuplique.site;
  }

  return useMutation<
    BienDetail,
    any,
    { referenceMandat: string; numeroLot: string }
  >(
    // @ts-ignore
    (params: { referenceMandat: string; numeroLot: string }) =>
      (api &&
        adbSelected &&
        site?.numero &&
        api.getBien(
          params.referenceMandat,
          params.numeroLot,
          adbSelected,
          site.numero
        )) ||
      undefined,
    {
      onSuccess: (data: BienDetail) => {
        BienActionCreator.lancerChargementBien(data);
      },
    }
  );
};

// export function* lancerChargementBien(
//   api: IApi,
//   action: ActionType<typeof BienActionCreator.lancerChargementBien.request>
// ) {
//   try {
//     const adbId = yield select(administrateurBienSelectors.getAdbId);
//     const adbDetail = yield select(administrateurBienSelectors.getADBDetail);
//     const adbSelected =
//       (adbId && adbId) || (adbDetail && adbDetail[0].identifiant);
//     let site = yield select(administrateurBienSelectors.getSelectedSite);

//     // chargement du site de la duplication
//     const refDossierDuplique = yield select(
//       dossierLocationSelectors.getDossierDuplique
//     );
//     if (refDossierDuplique) {
//       const dossiersLocation = yield select(
//         dossierLocationSelectors.getResultDossierLocation
//       );
//       const dossierDuplique =
//         dossiersLocation &&
//         dossiersLocation.elements.find(
//           (dos) => dos.reference === refDossierDuplique
//         );
//       site = dossierDuplique.site;
//     }
//     const { referenceMandat, numeroLot } = action.payload;
//     const resultat = yield call(
//       api.getBien,
//       referenceMandat,
//       numeroLot,
//       adbSelected,
//       site.numero
//     );
//     yield put(BienActionCreator.lancerChargementBien.success(resultat));
//   } catch (error) {
//     yield put(BienActionCreator.lancerChargementBien.failure(error));
//   }
// }

export const useGetTypeBien = () => {
  const api: IApi = Api.create(getApiEndpoint());

  //GET TYPES VOIE
  return useQuery<TypeBien[]>(
    "typeBien",
    () => api && api.loadTypeBienAsync(),
    {
      retry: false,
    }
  );
};

export const useGetNombrePieces = () => {
  const api: IApi = Api.create(getApiEndpoint());

  //GET TYPES VOIE
  return useQuery<NombrePieces[]>(
    "nombrePieces",
    () => api && api.loadNombrePieces(),
    {
      retry: false,
      onSuccess: (data) => {
        BienActionCreator.loadNombrePieces.success(data);
      },
    }
  );
};
